import { Text, Flex } from "@jsq/ds/core";
import { emptyStateText } from "./style_vanilla.css";

export const DashboardEmptyState = ({ className }: { className?: string }) => {
  return (
    <Flex flexDirection="column" alignItems="center" className={className}>
      <Text variant="h3" marginBottom="md">
        No workspaces assigned
      </Text>
      <Text variant="secondary-md" className={emptyStateText}>
        Once workspaces are assigned to you, you will be able to see them and log in to them
        from this page. Contact your administrator if you believe you should have access to
        workspaces
      </Text>
    </Flex>
  );
};
